import { RootState } from "@/store/store";
import { reservationsCoverageDataSelector } from "@/store/commitments/selectors/reservations/data/reservationsCoverageDataSelector";
import {
  CommitmentResourceType,
  ProviderType,
} from "@/services/cloudchipr.api";
import { azureReservationsCoverageDataSelector } from "@/store/commitments/selectors/azure/reservations/data/azureReservationsCoverageDataSelector";

export const isResourceTypeInReservationsCoverageSelector = (
  state: RootState,
  provider: ProviderType,
  resourceType: CommitmentResourceType,
): boolean => {
  const coverageData =
    provider === "azure"
      ? azureReservationsCoverageDataSelector(state)
      : reservationsCoverageDataSelector(state);
  const commitmentResourceType = resourceType.toLowerCase(); // todo: Change this to be lowercased from backend

  if (!coverageData) {
    return false;
  }

  return coverageData.some(
    (coverageItem) =>
      coverageItem?.resource_type?.resource_type?.toLowerCase() ===
      commitmentResourceType,
  );
};
